import { useEffect, useState, lazy } from "react";
import Navbar from "../../Component/navbar/Navbar";
import UserNavbar from "../../Component/user/UserNavbar";
import { useSelector } from "react-redux";
import "./style.css";
import "../BusinessCard/style.css";
import "../Guide/style.css";
import "../DigitalMedia/style.css";

import { activeMemberDataleft, activeMemberDataRight, dynamicQRData, qrCodeUses, StaticQRData } from "./constant";
import { Helmet } from "react-helmet";
import { Link, useNavigate } from "react-router-dom";
import Banner from "../../Component/Banner/Banner";

const Footer = lazy(() => import("../../Component/Footer/Footer"));
const KnowAbout = lazy(() => import("../../Component/KnowAbout/KnowAbout"));

const SolutionCard = () => {
  const navigate = useNavigate();
  const [showSidebar, setShowSidebar] = useState(false);
  const userState = useSelector((state) => state.user);
  const currentUserId = userState.currentUserId;
  useEffect(() => {
    window.scrollTo(0, 0);
  });
  return (
    <div className="wrapper">
      <Helmet>
        <title>QR Code Generator: Free, Dynamic & Static |QR Code Solution</title>
        <meta
          name="description"
          content="Create your own QR code Solution Offering both free static and dynamic QR code generator. Perfect for businesses, marketers, and personal use. Connect easily and instantly!"
        />
        <meta
          name="keywords"
          content="QR Code Solution                              QR Code Generator          Free Static QR Code                  Dynanic QR Code "
        />
        <meta name="theme-color" content="#008f68" />
        <link rel="canonical" href="https://www.qrcodebrew.com/qr-code-solution-card" />
      </Helmet>
      {currentUserId ? <UserNavbar setShowSidebar={setShowSidebar} showSidebar={showSidebar} /> : <Navbar />}

      <div className="qrbrew-main solutionCard">
        <section style={currentUserId ? { marginTop: "7vh" } : { marginTop: "1vh" }} className="mobile-mt-0">
          <Banner
            Title="Solution for Every Purpose"
            des="Scan, Solve, Simplify: QR Codes on Solution Cards! Unlock the power of convenience with QR codes on your solution card!"
          />
        </section>

        <section className="section-guide passup-section zero-display">
          {/* <div>
                            <p
                                className="passupText"
                                style={{ textAlign: "center" }}
                            >
                                Pass Up :{" "}
                            </p>
                        </div> */}

          <div className="container guide-pt-20" style={{ textAlign: "center" }}>
            <div className="row">
              <div className="col">
                <a href="#whatIs">
                  <p>
                    <nobr>What is QR</nobr>
                  </p>
                </a>
              </div>
              <div className="col">
                <a href="#whatCan">
                  <p>
                    <nobr>What QR Can Do</nobr>
                  </p>
                </a>
              </div>
              <div className="col">
                <a href="#dynamic">
                  <p>
                    <nobr>Dynamic</nobr>
                  </p>
                </a>
              </div>
              <div className="col">
                <a href="#bestQr">
                  <p>
                    <nobr>Best QR Code</nobr>
                  </p>
                </a>
              </div>
              <div className="col">
                <a href="#dynamicStatic">
                  <p>
                    <nobr>Dynamic & Static</nobr>
                  </p>
                </a>
              </div>
              {/* <div className='col' style={{  justifyContent:"center" }}>
                    <a href="#activeMember" style={{ width: "237px"}}><p><nobr>Benefits for Active Members</nobr></p></a>
                    </div> */}
              <div className="col">
                <a href="#faq">
                  <p>
                    <nobr>FAQ</nobr>
                  </p>
                </a>
              </div>
              {/* <div className='col text-center'>
                        <i className="fa-solid fa-briefcase"></i>
                        <p style={{ paddingRight: "0px" }}>Python</p>
                        </div> */}
            </div>
          </div>
        </section>

        <div className="container">
          {/* <h4 className="solutionHeading">Pass up :</h4>
                        <div className="sectionLink">
                            <a href="#whatIs">What is QR</a>
                            <a href="#whatCan">What QR Can Do</a>
                            <a href="#dynamic">Dynamic</a>
                            <a href="#bestQr">Best QR Code</a>
                            <a href="#dynamicStatic">Dynamic & Static</a>
                            <a href="#activeMember">Benefits for Active Member</a>
                            <a href="#faq">FAQ</a>
                        </div> */}

          {/* first Paragraph */}
          <section id="whatIs" className="sectionMain row">
            <div className="col-12 col-lg-6">
              <h3 className="sectionHeading">
                <span>What is </span> a QR Code?
              </h3>
              <p className="sectionText">
                A QR code is a two-dimensional barcode scanned using a smartphone or mobile device. By including a QR code on a solution card, businesses can
                direct users to a landing page or website to learn more about the product, view demos or tutorials, or even purchase.
              </p>
            </div>
            <div className="col-12 col-lg-6 qrImage">
              <div className="solutionQR">
                <div className="qrItem">
                  <img loading="lazy" src={'/assets/qrCode.webp'} alt="qrCode" />
                </div>
                <div className="qrItem">
                  <img loading="lazy" src={'/assets/qrCodeWidth.webp'} alt="qrCodeWidth" />
                </div>
              </div>
              <p className="qrNote">The clear difference between these two codes is their appearance</p>
            </div>
          </section>
          {/* second Paragraph */}
          <section id="whatCan" className="sectionMain row">
            <div className="col-lg-12">
              <h3 className="sectionHeading">
                <span>What can </span> a QR Code do?
              </h3>
              <p className="sectionText">
                QR codes on solution cards also provide a way for businesses to track engagement and measure the effectiveness of their marketing campaigns.{" "}
                <Link className="useAnchorLink" to="/qr-code-dynamic">
                  {" "}
                  free dynamic qr code
                </Link>{" "}
                on solution cards offer several benefits over traditional static codes. Dynamic codes can be edited and updated in real-time, allowing
                businesses to change the information or destination URL associated with the code without reprinting their solution cards.
              </p>
              <ul>
                <li>
                  Dynamic QR codes also offer enhanced tracking and analytics capabilities, allowing businesses to monitor the performance of their solution
                  cards in real time.
                </li>
                <li>Businesses can gain valuable insights by tracking the number of scans and conversions using Dynamic QR Codes.</li>
                <li>
                  Dynamic QR codes can also be personalized to the individual user, allowing businesses to create more tailored and engaging customer
                  experiences. By using data such as location, previous purchase history, or other user information, businesses can create customized landing
                  pages or offers that are more relevant to the individual user, increasing the likelihood of conversion and customer satisfaction.
                </li>
              </ul>
            </div>
          </section>
          {/* third Paragraph */}
          <section id="dynamic" className="sectionMain row">
            <div className="col-lg-12">
              <h3 className="sectionHeading">
                Why does the <span>Dynamic QR Code </span> solution need a subscription to work?
              </h3>
              <p className="sectionText">
                The Dynamic QR Code solution allows businesses to benefit from ongoing updates and new features as they are developed, ensuring they always have
                access to the latest, versatile, and most advanced tools and functionality. Without a subscription, businesses would need to handle the hosting
                and maintenance of the solution themselves, which can be time-consuming, expensive, and require technical expertise. A subscription-based model
                allows businesses to focus on their core operations and leave the technical details to the experts while reaping the benefits of a powerful and
                effective marketing tool.
              </p>
            </div>
          </section>
          {/* fourth Paragraph */}
          <section id="bestQr" className="sectionMain row">
            <div className="col-lg-12">
              <h3 className="sectionHeading">
                What are some of <span>the best QR Code examples and use cases</span> ?
              </h3>
              <p className="sectionText">
                QR codes are an important tool for businesses and organizations looking to enhance their marketing, improve operations, and engage with their
                audiences in new and innovative ways. With their versatility and ease of use,{" "}
                <Link to="/qr-code-business-card"> QR codes for businesses Cards</Link> looking to stay ahead in today's digital landscape.
              </p>
              {qrCodeUses?.map((item, i) => (
                <div key={item.id} className="useCaseContiner">
                  <h4>{item?.title}</h4>
                  {item?.heading === "anchorLink" ? (
                    <p>
                      Hotels and resorts can also use{" "}
                      <Link className="useAnchorLink" to="/">
                        {" "}
                        free qr code generator online
                      </Link>{" "}
                      to improve the guest experience and enhance operational efficiency.
                    </p>
                  ) : (
                    <p>{item?.heading}</p>
                  )}
                  <img loading="lazy" src={item?.image} alt="QR Code Solution" className="solutions-card-img" />
                  <ul>
                    {item?.list?.map((li, index) => (
                      <li
                        dangerouslySetInnerHTML={{
                          __html: li,
                        }}
                        key={li}
                      />
                    ))}
                  </ul>
                </div>
              ))}
            </div>
          </section>
          <section id="dynamicStatic">
            <div className="qrCodeSoultions row">
              <div onClick={() => navigate("/")} className="col-12 col-lg-6 extra">
                <h3>List of Dynamic QR Code solutions</h3>
                <div className="qrItemContainer">
                  {dynamicQRData?.map((item, i) => (
                    <div className="singleItem" key={item?.id}>
                      <img loading="lazy" src={item.image} alt={item.title + 1} className="Free, Dynamic & Static" />
                      <div className="itmeInfo">
                        <h6>{item.title}</h6>
                        <p>{item.heading}</p>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
              <div onClick={() => navigate("/")} className="col-12 col-lg-6">
                <h3 className="extra2">List of Static QR Code solutions</h3>
                <div className="qrItemContainer">
                  {StaticQRData?.map((item, i) => (
                    <div className="singleItem" key={item?.id}>
                      <img loading="lazy" src={item.image} alt={item.title + 1} className="Free, Dynamic & Static " />
                      <div className="itmeInfo">
                        <h6>{item.title}</h6>
                        <p>{item.heading}</p>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </section>
          {/* fifth Paragraph */}
          <section id="activeMember" className="sectionMain row">
            <div className="col-lg-12">
              <h3 className="sectionHeading">
                More benefits you will enjoy as a<span>premium member</span> are:
              </h3>
              <p className="sectionText">
                Because of its versatility, a QR Code can be programmed to do a multitude of things. It can be split into two formats: Dynamic and Static.
              </p>
              <div className="activeItems row">
                <div className="col-lg-6 leftItem extra3">
                  {activeMemberDataleft?.map((item, i) => (
                    <div className="activeSingleItem" key={item.id}>
                      <img loading="lazy" src={item.image} alt="" className="solutions-card-img" />
                      <div>
                        <h3>{item.title}</h3>
                        <p>{item.desc}</p>
                      </div>
                    </div>
                  ))}
                </div>
                <div className="col-lg-6 leftItem">
                  {activeMemberDataRight?.map((item, i) => (
                    <div className="activeSingleItem" key={item.id} onClick={item.title === "Helpful support" && (() => navigate("/help"))}>
                      <img loading="lazy" src={item.image} alt={item.title} className="solutions-card-img" />
                      <div>
                        <h3>{item.title}</h3>
                        <p>{item.desc}</p>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </section>
        </div>
        <hr />
        <div id="faq" className="container">
          <KnowAbout faq={true} />
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default SolutionCard;
